import { useEffect, useRef } from 'react'

const CHECK_INTERVAL = 60_000 // 1 minuto

export default function useVersionCheck() {
  const currentVersion = useRef<string | null>(null)
  const deferReload = useRef(false)

  useEffect(() => {
    if (import.meta.env.DEV) return

    function isUserTyping() {
      const el = document.activeElement
      return el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement || (el as HTMLElement)?.isContentEditable
    }

    async function checkVersion() {
      try {
        const res = await fetch('/version.json', { cache: 'no-store' })
        if (!res.ok) return
        const { version: serverVersion } = await res.json()

        if (!currentVersion.current) {
          currentVersion.current = serverVersion
          return
        }

        if (serverVersion !== currentVersion.current) {
          console.log('[SisPoli] Nova versão detectada, atualizando...')
          if (isUserTyping()) {
            deferReload.current = true
          } else {
            window.location.reload()
          }
        }
      } catch {
        // Silencioso — rede indisponível
      }
    }

    function onFocusOut() {
      if (deferReload.current) {
        window.location.reload()
      }
    }

    checkVersion()
    const interval = setInterval(checkVersion, CHECK_INTERVAL)
    document.addEventListener('focusout', onFocusOut)

    return () => {
      clearInterval(interval)
      document.removeEventListener('focusout', onFocusOut)
    }
  }, [])
}
